// extracted by mini-css-extract-plugin
export default {"fab":"FloatingButton_fab__o1kRh","starPulse":"FloatingButton_starPulse__UlM7F","tooltipContent":"FloatingButton_tooltipContent__taZZw","key":"FloatingButton_key__aUCLR"};